import { themeType } from "./theme_type";

const theme = {
    colors: {
        primary: '#0d6efd',
        secondary: '#d2e3fc',
        tertiary: '#E5F0F9',
        gray_0: '#FAFAFA',
        gray_3: '#F0EEEE',
        gray_5: '#EAEAEA',
        gray_10: '#DFDFDF',
        gray_20: '#D6D6D6',
        gray_30: '#D0D0D0',
        gray_40: '#C5C5C5',
        gray_50: '#9D9D9D',
        gray_60: '#6C6C6C',
        gray_70: '#595959',
        gray_80: '#474747',
        gray_90: '#3E3E3E',
        black: '#101010',
        white: '#FFFFFF',
        success_primary: '#31CA65',
        success_secondary: '#99ECB5',
        error_primary: '#B20000',
        error_secondary: '#FFB2B2',
        info_primary: '#1A227A',
        info_secondary: '#99C8F2',
    },
    breacks: {
        xsmall: '256px',
        small: '320px',
        medium: '768px',
        large: '1024px',
        xlarge: '1920px',
    }
} as themeType

export default theme;
